/**
 * Pre-call briefing — dark inverted surface for "read before your sales call"
 * summaries. Per CLAUDE.md: #171717 background, white text, accent-colored
 * labels. Intentionally looks different from the rest of the dashboard.
 *
 * Props:
 *   title : string                            — optional header
 *   items : [{ label, content }]              — label in accent caps, content in white
 *
 * Renders nothing when items is null/empty — pages pass the briefing straight
 * from the API payload, and an empty state should hide the section entirely.
 */
export function Briefing({ title, items }) {
  if (!items?.length) return null;
  return (
    <div className="rounded-card p-6 text-white" style={{ backgroundColor: "#171717" }}>
      {title && (
        <div className="pb-4 mb-5 border-b border-white/10">
          <div className="text-[13px] font-semibold">{title}</div>
          <div className="text-[11px] text-white/50 mt-0.5">
            Briefing · 5-minute read before your call
          </div>
        </div>
      )}
      <div className="space-y-4">
        {items.map((item, i) => (
          <div key={i} className="grid grid-cols-[140px_1fr] gap-5 items-start">
            <div
              className="text-[10px] uppercase text-accent font-semibold pt-0.5"
              style={{ letterSpacing: "0.5px" }}
            >
              {item.label}
            </div>
            <div className="text-[13px] leading-relaxed text-white/90">
              {item.content}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
